import { Link, useNavigate } from "react-router-dom";
import { arrow_right } from "../../../assets/icons";
import RegisterButton from "../../Header/RegisterButton/RegisterButton";
import SignInButton from "../../Header/SignInButton/SignInButton";
import styles from "./itemcontainer.module.css";
import { AccountContext } from "../../../Store/Account.store";
import { useContext } from "react";
import ProfileButton from "../../Header/ProfileButton/ProfileButton";

interface Props {
  isVisible: boolean;
  handleOnClick?: () => void;
}

export default function ItemContainer({ isVisible, handleOnClick }: Props) {
  const {accountData} = useContext(AccountContext);
  const navigate = useNavigate();
  function SendToSignIn() {
    handleOnClick && handleOnClick();
    navigate('/sign-in');
  }

  function SendToRegister() {
    handleOnClick && handleOnClick();
    navigate('/register');
  }

  return (
    <div
      className={`${styles.itemContainer} ${isVisible ? styles.visible : ""}`}
    >
      <h2 className={styles.menuHeader}>FOR BUYERS</h2>
      <ul className={styles.menuList}>
        <li>
          <Link onClick={handleOnClick} className={styles.menuLink} to="/search">
            Discover safer alternatives <span className={styles.arrowIcon}>{arrow_right}</span>
          </Link>
        </li>
      </ul>
      <h2 className={styles.menuHeader}>FOR SUPPLIERS</h2>
      <ul className={styles.menuList}>
        <li>
          <Link onClick={handleOnClick} className={styles.menuLink} to="/advertise-your-alternative">
            Advertise your alternative <span className={styles.arrowIcon}>{arrow_right}</span>
          </Link>
        </li>
      </ul>
      <h2 className={styles.menuHeader}>ABOUT MARKETPLACE</h2>
      <ul className={styles.menuList}>
        <li>
          <Link onClick={handleOnClick} className={styles.menuLink} to="/safer-alternative">
            What is a safer alternative? <span className={styles.arrowIcon}>{arrow_right}</span>
          </Link>
        </li>
        <li>
          <Link onClick={handleOnClick} className={styles.menuLink} to="/terms-conditions">
            Terms & Conditions <span className={styles.arrowIcon}>{arrow_right}</span>
          </Link>
        </li>
      </ul>
      <div className={styles.profileContainer}>
        {!accountData.isauthenticated ?
        (  <>
            <RegisterButton isInMenu={true} HandleOnClick={SendToRegister}/>
            <SignInButton isInMenu={true} handleOnClick={SendToSignIn}/>
          </>): (
            <>
              <Link onClick={handleOnClick} to="/advertise-your-alternative" className={`${styles.advertiseButton} button`}>Advertise your alternative</Link>
              <ProfileButton isInMenu={true} greenText={true}/>
            </>
          )
        }
      </div>
    </div>
  );
}
